import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import { useModifyMeasure } from "../../api/hooks/allHooks";
import { normalRetrofitDataToPerM2 } from "../../utils/general";
import { BuildingArea } from "../BuildingProfile/types";
import { FormField } from "../DynamicForm";
import ItemPopUpForm, { MutateInputs } from "../ItemPopUpForm";

type CreatRetrofitMeasureFormProps = {
  building: BuildingArea;
  formItems: FormItem[];
  initialFormData?: Record<string, unknown>;
  isOpen: boolean;
  isPerM2: boolean;
  projectId: number | string;
  requiredFields?: string[];
  rowId: number;
  setIsOpen: (isOpen: boolean) => void;
};

type FormItem = FormField & { optionsFn?: (formData: Record<string, unknown>) => string[] };

const EditRetrofitMeasureForm: React.FC<CreatRetrofitMeasureFormProps> = ({
  building,
  formItems,
  initialFormData,
  isOpen,
  isPerM2,
  projectId,
  requiredFields,
  rowId,
  setIsOpen,
}) => {
  const { t } = useTranslation();
  const { isLoading, mutate } = useModifyMeasure();
  const { user } = useSelector((store: any) => store.user);

  const mutateWithPerM2Conversion = (props: MutateInputs) => {
    const { data, ...rest } = props;
    const perM2Data = isPerM2 ? data : normalRetrofitDataToPerM2({ building, retrofitData: data });
    mutate({
      data: { ...perM2Data, project: projectId, user: user?.user_id },
      ...rest,
    });
  };

  return (
    <ItemPopUpForm
      formItems={formItems}
      initialFormData={initialFormData}
      isOpen={isOpen}
      isSubmitting={isLoading}
      mutate={mutateWithPerM2Conversion}
      projectId={projectId}
      requiredFields={requiredFields}
      rowId={rowId}
      setIsOpen={setIsOpen}
      title={
        isPerM2
          ? t("Modernization.wizard.editMeasureForm.titlePerM2") || ""
          : t("Modernization.wizard.editMeasureForm.title") || ""
      }
    />
  );
};

export default EditRetrofitMeasureForm;
